import { Link } from '@mui/material';

import { usePath } from '@cast/utils';

import { Link as RouterLink } from 'components/router';
import { makeNamespaceCostMonitoringLink } from 'features/cluster/cost-report/links';

import { useCluster } from '@cast/shared-cluster-context-data-access';

import { LinkBehaviour, Typography } from '@cast/design-system';

type Props = {
  namespace: string | undefined;
  clusterId?: string;
};

export const NamespacesLinkCell = ({ namespace, clusterId }: Props) => {
  // TODO: get rid of useCluster() (temporary solution to avoid missing params errors)
  /*
    dispatchReplaceStateEvent() and CustomEvent (REPLACE_STATE_EVENT) cause missing param issues.
    CustomEvent is being sent with a delay, causing the usePath() handler to receive the old URL (window.location.pathname) when attempting to create a link and extract parameters that do not exist in buildLinkToReport()
    */
  const { cluster } = useCluster();
  const _clusterId = clusterId || cluster?.id;
  const paramsNotEmpty = !!namespace?.length && !!_clusterId.length;
  const link = usePath(
    () => makeNamespaceCostMonitoringLink({ clusterId: _clusterId, namespace }),
    { enabled: paramsNotEmpty }
  );

  if (!paramsNotEmpty) {
    return (
      <Typography component="span" variant="inherit">
        {namespace || ''}
      </Typography>
    );
  }

  return (
    <Link to={link} component={RouterLink} underline="none">
      <LinkBehaviour variant="inherit" fontWeight={500} noWrap>
        {namespace}
      </LinkBehaviour>
    </Link>
  );
};
